import React, { Component } from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { getFileStatus } from "../../utils/fileStatus";
import ExcelQueryMailSubReport from "./ExcelQueryMailSubReport";

interface AllProps {
  reports: any[];
  redirectToDashboard?: any;
}

export default class QueryMailReportTable extends Component<AllProps> {
  render() {
    const { reports = [], redirectToDashboard = () => {} } = this.props;

    const columns = [
      { header: "S.No", key: "serial", td: (item) => <span onClick={() => redirectToDashboard(item.id)}>{item.serial}</span> },
      { header: "File Name", key: "file_name", td: (item) => <span onClick={() => redirectToDashboard(item.id)}>{item.file_name}</span> },
      { header: "Prosses Officer", key: "prosses_officer", td: (item) => <span onClick={() => redirectToDashboard(item.id)}>{item.prosses_officer}</span> },
      { header: "Query Received Via Mail Date", key: "query_received_via_mail_date", td: (item) => <span onClick={() => redirectToDashboard(item.id)}>{item.query_received_via_mail_date}</span> },
      { header: "Query Mail Closing Reason", key: "query_mail_closing_reason", td: (item) => <span onClick={() => redirectToDashboard(item.id)}>{item.query_mail_closing_reason}</span> },
    ];

    const processedData = reports.map((report, index) => ({
      serial: index + 1,
      ...report,
      file_status: report.file_status ? getFileStatus(report.file_status) : "",
    }));

    return (
      <div>
        <div className="row">
          <div className="col-xl-12 col-md-12 p-3">
            {processedData.length > 0 && <ExcelQueryMailSubReport data={processedData} />}
          </div>
        </div>
        <ReactFlexyTable
          className="assigned-table"
          data={processedData}
          columns={columns}
          sortable
          pageSize={10}
          globalSearch
        />
      </div>
    );
  }
}
